'use client';

import type { ReactNode } from 'react';
import type { UniswapV4Adapter } from '../../data/mock-adapters';
import { AdapterPanelShell, Stat, StatGrid2 } from './AdapterPanelShell';
import { pairToCoinSymbol } from './pair-utils';

/**
 * Uniswap v4 LP adapter panel.
 *
 * Mirrors the Flaunch / Uniswap v3 panels' 2-stat layout (TVL + Coin)
 * so every adapter card reads the same shape and only the brand icon
 * differentiates them. The previous 6-stat grid (Fee / APR / TVL /
 * Hook / Pair / Accrued) gave the card a "trade the LP" framing that
 * competed with the adapter's actual purpose (fund seat rewards); the
 * v4-specific hook descriptor / fee tier now live on the linked
 * Uniswap pool page, and the Accrued column was retired alongside
 * the other adapters' for the same "duplicates RewardsPanel" reason.
 */
export function UniswapV4AdapterPanel({
  adapter,
  belowStats,
}: {
  adapter: UniswapV4Adapter;
  belowStats?: ReactNode;
}) {
  return (
    <AdapterPanelShell
      adapter={{ ...adapter, label: adapter.label ?? `Uniswap v4 · ${adapter.pair}` }}
      belowStats={belowStats}
    >
      <StatGrid2>
        <Stat label="TVL" value={adapter.tvlUsd} />
        <Stat label="Coin" value={pairToCoinSymbol(adapter.pair)} />
      </StatGrid2>
    </AdapterPanelShell>
  );
}
